import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TableInfo} from '../../models/tableInfo';
import {PrivacyService} from '../../core/services/privacy/privacy.service';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: []
})
export class InfoModalComponent implements OnInit {

  disclaimer: string;
  disclaimerExists: boolean;

  constructor(
    private disclaimerService: PrivacyService,
    public dialogRef: MatDialogRef<InfoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TableInfo
  ) { }

  ngOnInit(): void {
    this.disclaimerExists = this.disclaimerService.getPrivacyDisclaimer().exists;
    this.disclaimer = this.disclaimerService.getPrivacyDisclaimer().description;
  }

  closeModal() {
    this.dialogRef.close(true);
  }
}
